import axios from 'axios';
import { config } from '../../Configs';

export const getConstructorContractsAPI = async authToken => {
  try {
    const response = await axios.get(`${config.api.url}/constructors`, {
      headers: { Authorization: authToken }
    });
    return { success: true, data: response.data.data };
  } catch (err) {
    return { success: false, error: err };
  }
};

export const getConstructorContractAPI = async (authToken, contractId) => {
  try {
    const response = await axios.get(
      `${config.api.url}/constructors/${contractId}`,
      {
        headers: { Authorization: authToken }
      }
    );
    return { success: true, data: response.data.data };
  } catch (err) {
    return { success: false, error: err };
  }
};

export const getConstructorInvoicesAPI = async (authToken, contractId) => {
  try {
    const response = await axios.get(
      `${config.api.url}/constructors/${contractId}/invoices`,
      {
        headers: { Authorization: authToken }
      }
    );
    return { success: true, data: response.data.data };
  } catch (err) {
    return { success: false, error: err };
  }
};

export const CreateConstructorContactAPI = async (
  token,
  {
    firstName,
    lastName,
    identification,
    identificationType,
    contractId,
    department,
    locality,
    email,
    cellPhoneNumber,
    description
  }
) => {
  try {
    const response = await axios.post(
      `${config.api.url}/constructors/contact-me`,
      {
        firstName,
        lastName,
        identification,
        identificationType,
        contractId,
        department,
        locality,
        email,
        cellPhoneNumber,
        description
      },
      {
        headers: {
          Authorization: token
        }
      }
    );
    return { success: true, data: response.data.data };
  } catch (err) {
    return { success: false, error: err };
  }
};

export const createConstructorRequestAPI = async (
  token,
  quotationRequestData
) => {
  try {
    const response = await axios.post(
      `${config.api.url}/constructors/request`,
      quotationRequestData,
      {
        headers: {
          Authorization: token
        }
      }
    );
    return { success: true, data: response.data.data };
  } catch (err) {
    return { success: false, error: err };
  }
};
